export const messageBubbleMinWidth = 50
export const messageBubbleMinHeight = 36
